import { cn } from '@/lib/cn'
import type { ReactNode } from 'react'

interface Props {
  label: string
  children: ReactNode
  className?: string
}

export function InfoRow({ label, children, className }: Props) {
  return (
    <div className={cn('flex flex-col gap-1', className)}>
      <dt className="text-xs text-muted-foreground">{label}</dt>
      <dd className="text-sm text-foreground">{children}</dd>
    </div>
  )
}
